import { QuestionMarkCircleIcon } from "@heroicons/react/solid";
import styles from "./QuestionMarkTooltip.module.css";

export default function QuestionMarkTooltip({
  toolTip,
  customClassName,
}: {
  toolTip: string;
  customClassName?: string;
}) {
  return (
    <>
      <div
        className={`w-full text-neutralColor-light cursor-pointer hover:text-neutralColor-medium transition duration-300 ease-in-out ${styles["hover-trigger"]}`}>
        <QuestionMarkCircleIcon className="w-5 h-5" />
        <div
          className={` ${styles["item-bubble"]} ${styles["hover-target"]} ${customClassName}`}>
          {toolTip}
        </div>
      </div>
    </>
  );
}
